module.exports = require("@nrwl/workspace/src/core/file-utils");